import { httpService } from "../http"
import { VersionResponse } from "./version";

const REACT_APP_GO_MICRO = process.env.REACT_APP_GO_MICRO;

export const getAppLink = (): Promise<VersionResponse> => {
  return httpService.get("/mp2c-micro/platform/app/version/official", {}, { baseURL: REACT_APP_GO_MICRO });
}
